import store from '../store/index.js'
//通过自定义全局指令，控制增删改按钮的隐藏
let menu = store.state.menusList
//从数组里的每个对象拿一个字段pid，合成新的数组
let menu_rights = menu.map(obj =>{return obj.pid})
//console.log(menu_rights)
//判断权限！
function checkArray(key) {
 let arr = menu_rights
  let index = arr.indexOf(key)
  if (index > -1) {
    return true // 有权限
  } else {
    return false // 无权限
  }
}
//全局指令 v-directiive
const Dclrights = {}
Dclrights.install=Vue=>{
	Vue.directive('Dclrights',{
		inserted(el, binding) {
		  let Dclrights = binding.value // 获取到 v-permission的值
		  if (Dclrights) {
		    let hasPermission = checkArray(Dclrights)
		    if (!hasPermission) {
		      // 没有权限 移除Dom元素
		      el.parentNode && el.parentNode.removeChild(el)
		    }
		  }
		}
	})
}
export default Dclrights